import decode from 'jwt-decode';
import { WRITE_JOBS, } from '../types/types';
export var getRawDecodedLinkTokenPayload = function (linkToken) { return decode(linkToken); };
function getPlatformId(rawToken) {
    if (rawToken.data.platform_id)
        return rawToken.data.platform_id;
    return undefined;
}
export var getLinkTokenPayload = function (linkToken) {
    var _a, _b;
    var decoded = getRawDecodedLinkTokenPayload(linkToken);
    var _c = decoded.data, data = _c === void 0 ? {} : _c;
    return {
        solution: data.solution,
        features: (_a = data.features) === null || _a === void 0 ? void 0 : _a.map(function (x) {
            return x === 'direct_deposit_payment' ? 'direct_deposit_switch' : x;
        }),
        requiredJobs: (_b = data.required_jobs) === null || _b === void 0 ? void 0 : _b.map(function (x) {
            return x === 'direct_deposit_payment' ? 'direct_deposit_switch' : x;
        }),
        mode: data.mode,
        orgName: data.org_name,
        accountName: data.account_name,
        accountType: data.account_type,
        accountNumber: data.account_number,
        routingNumber: data.routing_number,
        platformKey: data.platform_key,
        amount: data.amount,
        skipIntroScreen: data.skip_intro_screen,
        tokenId: data.token_id,
        apiKey: data.api_key,
        employerSearchTerm: data.employer_search_term,
        employerId: data.employer_id,
        platformId: getPlatformId(decoded),
        disableDirectDepositSplitting: data.disable_direct_deposit_splitting,
        accountId: data.account_id,
        skipDepositConfirmation: data.skip_deposit_confirmation,
        missingUserAuthenticationFields: data.missing_user_authentication_fields,
        platformType: data.platform_type,
        language: data.language,
        workspaceName: data.workspace_name,
        _uid: data._uid,
        allocation: data.allocation
            ? {
                type: data.allocation.type,
                value: data.allocation.value,
                minAmount: data.allocation.min_amount,
                targets: data.allocation.targets.map(function (target) { return ({
                    name: target.name,
                    type: target.type,
                    routingNumber: target.routing_number,
                    accountNumber: target.account_number,
                }); }),
            }
            : null,
        endUserId: data.end_user_id,
        enableCardSwitch: data.enable_card_switch,
        smartBranch: data.smart_branch,
        card: data.card
            ? {
                cardName: data.card.card_name,
                maskedCardNumber: data.card.card_name,
            }
            : null,
        documentUploads: data.document_uploads,
        enableUserInputBankInfo: data.enable_user_input_bank_info,
        hasUserAuthenticationData: data.has_user_authentication_data,
        enableSelfId: data.enable_self_id,
        depositForms: data.deposit_forms,
        tags: data.tags,
        isAppClip: data.is_app_clip,
        enableBillNavigator: data.enable_bill_navigator,
        homerUrl: data.homer_url,
    };
};
export var getWriteJobFromToken = function (payload) {
    return WRITE_JOBS.find(function (v) { return payload.requiredJobs.includes(v); }) || null;
};
export var tokenHasJob = function (payload, job) {
    return payload.requiredJobs.includes(job);
};
export var tokenHasPlatform = function (_a) {
    var platformKey = _a.platformKey, platformId = _a.platformId, accountId = _a.accountId, employerId = _a.employerId;
    return platformKey || platformId || accountId || employerId;
};
